import { TextField } from "@mui/material";
import { ClockPickerView, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import { useEffect } from "react";
import { FieldValues, UseFormRegister, UseFormWatch } from "react-hook-form";

interface Props {
  register?: UseFormRegister<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  onChange: (value: Dayjs | null) => void;
  label: string;
  required?: boolean | string;
  id: string;
  sx?: any;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  views?: ClockPickerView[];
}
export const TimePickerField: React.FC<Props> = ({
  onChange,
  label,
  register,
  id,
  required,
  watch,
  sx,
  disabled = false,
  error = false,
  helperText = "",
  views,
}) => {
  const value = watch(id);
  useEffect(() => {
    if (register) {
      register(id, { required });
    }
  }, []);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        label={label}
        value={value}
        onChange={onChange}
        views={views}
        renderInput={(params) => <TextField size="small" {...params} error={error} helperText={helperText} />}
      />
    </LocalizationProvider>
  );
};
